import utils from '../utils/utils'
import { animate } from 'animejs';

class ArchiveBlog {
  constructor() {
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.page = document.querySelector('.template-archive-blog');
      cache.loadMoreBtn = cache.page.querySelector('.load-more-btn');
    };

    let registerEvents = () => {
      cache.loadMoreBtn.addEventListener('click', loadMore);
    };

    let loadMore = function() {
      const btn = this;
      const parent = btn.closest('.module_articles');
      const articles = parent.querySelectorAll('.article_hidden');
      animate(btn, {
          opacity: [1, 0],
          duration: 300,
          ease: 'outSine',
          onComplete: function() {
            btn.style.display = 'none';
          }
      });
      for (let i = 0; i < articles.length; i++) {
        articles[i].classList.remove('article_hidden');
        animate(articles[i], {  
          opacity: [0, 1],
          translateY: [60, 0],
          delay: 100 * i,
          duration: 500,
          ease: 'outSine',
        });
      }
    };

    initFunc();
  };
}
export { ArchiveBlog }
